import { diditInboxQueryKeys as e } from "./diditInboxQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { verificationApi as n } from "@maat/api-main";
//#region src/verification/admin/useDiditInboxStatsQuery.ts
var r = () => t({
	queryKey: e.stats(),
	queryFn: () => n.adminDiditInboxStats()
});
//#endregion
export { r as useDiditInboxStatsQuery };
